import { UserRound } from 'lucide-react';
import { DetailPanel } from '@/components/common/DetailPanel';
import { LabelWithValue } from '@/components/common/LabelWithValue';
import { Skeleton } from '@/components/ui/skeleton';
import type { SurveySubmissionDetail } from '../types/survey.types';

interface PersonField {
  key: string;
  label: string;
  getValue: (submission: SurveySubmissionDetail) => string | null;
}

const PERSON_FIELDS: PersonField[] = [
  { key: 'name', label: 'Name', getValue: (s) => s.userName },
  { key: 'department', label: 'Department', getValue: (s) => s.departmentName },
  { key: 'reportingTo', label: 'Reporting To', getValue: (s) => s.reportingToName },
  { key: 'division', label: 'Division', getValue: (s) => s.divisionName },
  { key: 'district', label: 'District', getValue: (s) => s.districtName },
  { key: 'thana', label: 'Thana', getValue: (s) => s.thanaName },
];

interface SurveySubmissionPersonPanelProps {
  submission: SurveySubmissionDetail | undefined;
}

export function SurveySubmissionPersonPanel({ submission }: SurveySubmissionPersonPanelProps) {
  return (
    <DetailPanel title="Respondent" icon={UserRound}>
      <dl className="grid grid-cols-2 gap-4 lg:grid-cols-1">
        {PERSON_FIELDS.map((field) => (
          <LabelWithValue key={field.key} label={field.label}>
            {submission ? field.getValue(submission) : <Skeleton className="h-5 w-32" />}
          </LabelWithValue>
        ))}
      </dl>
    </DetailPanel>
  );
}
